import {PageWrapper} from '@/components/ui/page-atoms/PageAtoms'
import styled, {css} from 'styled-components'

export const StyledHomePageWrapper = styled(PageWrapper)`
    grid-template-columns: 1fr;
`
export const StyledHomeWrapper = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: grid;
        padding: ${spacing * 4}px;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledDashboardWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px;
        border: 1px solid ${palette.neutral[200]};
        overflow: hidden;
    `
)
